export const ERROR_MSG = {
  WRONG_PASS: 'The password you entered is incorrect.',
  PASS_NOT_MATCH: 'Passwords don’t match.',
  PASSWORD_REQUIREMENTS:
    'Password should contain 8-20 symbols , including lower case letter, upper case letter and a number.',
  NOT_MATCH: 'Password not match',
  WRONG_VERIFICATION_CODE: 'The Verification Code you entered is incorrect.',
  VALID_LOGIN: 'You have entered an invalid email address / phone number.'
};
